import { IconX } from "@tabler/icons-react";
import React from "react";
import { toast } from "sonner";

interface ErrorToastProps {
  message: string | React.ReactNode;
}

export const ErrorToast = ({ message }: ErrorToastProps) => {
  toast.custom(() => (
    <div className="flex items-center gap-3 p-4 bg-[#f79494] text-black font-montserrat text-xs font-medium rounded shadow-md">
      <IconX className="text-black" />
      <div>
        {typeof message === "string" ? (
          <p className="font-semibold">{message}</p>
        ) : (
          message
        )}
      </div>
    </div>
  ));
};
